import React, { useEffect, useMemo, useState } from "react";
import Breadcrumb from "../../components/common/Breadcrumb";
import ReactDataTable from "react-data-table-component";
import {
  IconEdit,
  IconFilter,
  IconTrash,
  IconAlertCircle,
  IconClipboard,
} from "@tabler/icons-react";
import {
  getDepartments,
  getdutywithdate,
  getEmployee,
  getShifEmployees,
  getShift,
  InsertDuty,
} from "../../services/dataService";
import Loading from "../../components/common/Loading";
import toast from "react-hot-toast";
import Select from "react-select";
import FilterComponent from "../pages/FilterComponent";
import { Link, useNavigate } from "react-router-dom";
import { useLocation } from "react-router-dom";

export default function Duty() {
  const UID = localStorage.getItem("userId");
  const DepartmentName = localStorage.getItem("DepartmentName");
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [editCategoryModal, setEditCategoryModal] = useState(false);
  const [duties, setduties] = useState([]);
  const [dataFilter, setDataFilter] = useState([]);
  const [department, setDepartment] = useState([]);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = React.useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [categoryIdToDelete, setcategoryIdToDelete] = useState(null);
  const [date, setDate] = useState("");
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [resetPaginationToggle, setResetPaginationToggle] =
    React.useState(false);
  const isAdmin = localStorage.getItem("IsAdmin");
  const [processedData, setProcessedData] = useState([]);
  const [tempShift, setTempShift] = useState([]);
  const [employee, setEmployee] = useState([]);
  const location = useLocation();
  const [shiftemployeedata, setShiftEmployeesData] = useState([]);
  const [shiftData, setShiftData] = useState([]);
  const departmentIds = localStorage.getItem("DepartmentId") || "";
  const DepId = departmentIds.split(",")[0] || null;
  const [shiftemployeeOptions, setShiftemployeeOptions] = useState([]);
  const [open, setOpen] = React.useState(false);
  const [toDate, setToDate] = useState("");
  const getTodayDate = (isAdmin) => {
    const date = new Date();
    if (isAdmin == 0) {
      // set to yesterday
      date.setDate(date.getDate() - 1);
    }
    return date.toISOString().split("T")[0];
  };

  const [dutyData, setDutyData] = useState({
    Id: "",
    EmpId: [],
    ShiftId: "",
    DeptId: "",
    Remarks: "",
    DepartmentId: "",
    DateValue: getTodayDate(),
    AddedBy: "",
    ToDate: getTodayDate(), // Initialize ToDate to today's date
  });
  const { state } = useLocation();
  const [locationState, setLocationState] = useState(state?.EmpId || null); // Use null instead of {} for clarity, assuming EmpId is a string or number

  const navigate = useNavigate();

  const handleview = (row) => {
    navigate("/consolidatedduty", {
      state: {
        ...row,
        date: date,
        ToDate: toDate ? toDate : new Date().toISOString().split("T")[0],
      },
    });
  };

  const openAddCategoryModal = () => {
    if (isAdmin == 0) {
      const departmentId = localStorage.getItem("DepartmentId");

      // Filter shifts by departmentId (comma separated in DB)
      let matchWithShift = tempShift.filter((el) =>
        el.DepartmentId?.split(",")
          .map((d) => d.trim())
          .includes(departmentId)
      );

      // Remove duplicates by Id
      let uniqueShifts = Array.from(
        new Map(matchWithShift.map((s) => [s.Id, s])).values()
      );

      let finalShiftData = uniqueShifts;

      // Add holiday/other shifts if department contains "iti"
      if (DepartmentName?.toLowerCase().includes("iti")) {
        const holidayShifts = tempShift.filter(
          (el) =>
            el.Name?.toLowerCase().includes("holiday") ||
            el.Name?.toLowerCase().includes("other")
        );

        const merged = [...uniqueShifts];
        holidayShifts.forEach((shift) => {
          if (!merged.find((el) => el.Id === shift.Id)) {
            merged.push(shift);
          }
        });

        finalShiftData = merged;
      }

      setShiftData(finalShiftData);
    }

    setDutyData({
      Id: "",
      EmpId: [],
      ShiftId: "",
      DeptId: "",
      Remarks: "",
      DateValue: getTodayDate(),
      AddedBy: "",
      DepartmentId: isAdmin === "0" ? DepId : "",
      ToDate: "",
    });

    setAddCategoryModal(true);
  };

  const closeAddCategoryModal = () => {
    setAddCategoryModal(false);
    setLocationState({}); // Clear local copy of location.state
  };

  const fetchduties = async () => {
    const selectedDate =
      location.state?.date || date || new Date().toISOString().split("T")[0];
    const data = {
      Date: selectedDate,
      ToDate: toDate || new Date().toISOString().split("T")[0],
      UserId: UID,
    };
    try {
      setLoading(true);
      const response = await getdutywithdate(data);
      const details =
        isAdmin == 1
          ? response?.data?.data
          : response?.data?.data?.filter((el) => el?.DepartmentID == DepId);
      setduties(details);
    } catch (error) {
      console.error("Error fetching duty data", error);
    } finally {
      setLoading(false);
    }
  };

  const handleShowClick = async () => {
    fetchduties();
  };

  const clearData = () => {
    setDutyData({
      Id: "",
      EmpId: [],
      ShiftId: "",
      DeptId: "",
      Remarks: "",
      DateValue: getTodayDate(),
      AddedBy: "",
      DepartmentId: isAdmin == 0 ? DepId : "",
    });
  };

  const handleChange = (selectedOptions) => {
    if (isAdmin == 1) {
      if (selectedOptions.target.name === "DepartmentId") {
        const selectedDepId = selectedOptions.target.value;
        sessionStorage.setItem("AddDutyDep", selectedDepId);

        // Filter shifts by DepartmentId (comma separated)
        let matchWithShift = tempShift.filter((el) =>
          el.DepartmentId?.split(",")
            .map((d) => d.trim())
            .includes(selectedDepId)
        );

        // Remove duplicates by Id
        let uniqueShifts = Array.from(
          new Map(matchWithShift.map((s) => [s.Id, s])).values()
        );
        let finalShiftData = uniqueShifts;

        const selectedDepName = department.find(
          (el) => el.Id == selectedDepId
        )?.Name;

        // Add holiday/other shifts if department contains "iti"
        if (selectedDepName?.toLowerCase().includes("iti")) {
          const holidayShifts = tempShift.filter(
            (el) =>
              el.Name?.toLowerCase().includes("holiday") ||
              el.Name?.toLowerCase().includes("other")
          );

          const merged = [...uniqueShifts];
          holidayShifts.forEach((shift) => {
            if (!merged.find((el) => el.Id === shift.Id)) {
              merged.push(shift);
            }
          });

          finalShiftData = merged;
        }

        setShiftData(finalShiftData);
      }
    }

    // ✅ Employee checkbox case
    if (
      selectedOptions &&
      selectedOptions.target &&
      selectedOptions.target.type === "checkbox"
    ) {
      const { value, checked } = selectedOptions.target;
      setDutyData((prev) => {
        const updatedEmpIds = checked
          ? [...(prev.EmpId || []), value]
          : (prev.EmpId || []).filter((id) => id !== value);
        return {
          ...prev,
          EmpId: updatedEmpIds,
        };
      });
      return;
    }

    // ✅ Multi-select (React-Select type)
    if (selectedOptions && Array.isArray(selectedOptions)) {
      const selectedEmployeeIds = selectedOptions.map((option) => option.value);
      setDutyData((prev) => ({
        ...prev,
        EmpId: selectedEmployeeIds,
        Id: "",
      }));
      return;
    }

    // ✅ Normal input / date handling
    if (selectedOptions && selectedOptions.target) {
      const { name, value } = selectedOptions.target;

      if (name === "DateValue" || name === "ToDate") {
        const today = new Date().toISOString().split("T")[0];
        if (name === "DateValue" && value < today) {
          toast.error("You cannot select a past date!");
          return;
        }

        setDutyData((prev) => {
          const updatedData = { ...prev, [name]: value };
          if (updatedData.DateValue && updatedData.ToDate) {
            if (updatedData.DateValue > updatedData.ToDate) {
              toast.error(
                "The 'From Date' cannot be after the 'To Date'. Please select valid dates."
              );
              return prev;
            }
          }
          return updatedData;
        });
      } else {
        setDutyData((prev) => ({
          ...prev,
          [name]: value,
        }));
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const updatedDutyData = {
        ...dutyData,
        UserId: UID,
      };
      const response = await InsertDuty(updatedDutyData);
      if (response) {
        toast.success(response?.data?.message || "inserted successfully");
        if (response?.data?.skippedMessages) {
          toast.success(response?.data?.skippedMessages);
        }
        fetchShiftEmployees();
        fetchduties();
        closeAddCategoryModal();
      } else {
        console.error("Error response:", response?.data?.error);
        toast.error(response?.data?.error);
      }
    } catch (error) {
      console.error("Error during submission:", error);
      toast.error(error?.response?.data.error);
    } finally {
      setLoading(false);
      handleClose();
    }
  };

  const columnsFilter = [
    {
      name: "Sl No",
      cell: (row, index) => {
        const firstRow = filteredItems.indexOf(row);
        return firstRow + 1;
      },
      grow: 0,
      width: "60px",
    },
    {
      name: "Shift",
      selector: (row) => row.ShiftName,
      sortable: true,
    },
    {
      name: "StartTime",
      selector: (row) => row.StartTime,
      sortable: true,
    },
    {
      name: "EndTime",
      selector: (row) => row.EndTime,
      sortable: true,
    },
    {
      name: "No of Allocations",
      selector: (row) => row.count,
      sortable: true,
    },
    {
      name: "Action",
      selector: (row) => (
        <div className="flex items-stretch gap-10">
          <button
            className="btn btn-primary rounded-[4px] px-10 py-[8px]"
            onClick={() => {
              handleview(row);
            }}
          >
            View More
          </button>
        </div>
      ),
    },
  ];

  const filteredItems = processedData?.filter((item) => {
    return (
      item?.ShiftName?.toLowerCase().includes(filterText.toLowerCase()) ||
      item?.count == filterText
    );
  });

  const formatTime = (timeStr) => {
    const date = new Date(timeStr);
    const hours = date.getUTCHours().toString().padStart(2, "0");
    const minutes = date.getUTCMinutes().toString().padStart(2, "0");
    return `${hours}:${minutes}`;
  };

  const processData = (data) => {
    const shiftMap = data.reduce((acc, item) => {
      if (!acc[item.ShiftName]) {
        acc[item.ShiftName] = {
          ShiftName: item.ShiftName,
          StartTime: formatTime(item.StartTime),
          EndTime: formatTime(item.EndTime),
          count: 0,
        };
      }
      acc[item.ShiftName].count += 1;
      return acc;
    }, {});

    return Object.values(shiftMap);
  };

  const subHeaderComponentMemo = useMemo(() => {}, [
    filterText,
    resetPaginationToggle,
  ]);

  const fetchShiftEmployees = async () => {
    const payload = {
      Date: dutyData.DateValue,
      UserId: UID,
    };

    try {
      const response = await getShifEmployees(payload);
      const resultData = response.data.data;
      const details =
        isAdmin == 1
          ? resultData
          : resultData.filter((el) => el.DepartmentID == DepId);

      const finalFilter = details.filter((el) => el.DutyAllocation === true);

      setShiftEmployeesData(finalFilter);
    } catch (error) {
      console.error("Error fetching ShiftEmployees", error);
    }

    setLoading(false);
  };

  const fetchShifts = async () => {
    try {
      const data = await getShift(UID);
      setTempShift(data.data.data);
    } catch (error) {
      console.error("Error fetching shifts", error);
    }
  };

  // Filter shifts based on selected employees' DeShiftId
  const filteredShifts = shiftData;

  const handleFilterClick = () => {
    setIsFilterVisible(!isFilterVisible);
  };

  const handleFilter = (filteredResults) => {
    setDataFilter(filteredResults);
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const handleClickOpen = (e) => {
    e.preventDefault();
    if (dutyData?.EmpId.length > 0) {
      setOpen(true);
    } else {
      toast.error("Please Select at least one employee");
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const confirmationMessage = `Are you sure you want to add all these employees to the "${
    shiftData?.find((el) => el.Id === dutyData.ShiftId)?.Name || "Unknown"
  } shift" from ${dutyData?.DateValue} to ${dutyData?.ToDate}?`;

  useEffect(() => {
    if (locationState && shiftemployeedata.length > 0) {
      const selectedEmployee = shiftemployeedata.find(
        (employee) => employee.Id === locationState
      );
      if (selectedEmployee) {
        setDutyData((prev) => ({
          ...prev,

          EmpId: [locationState],
          DepartmentId: selectedEmployee.DepartmentID,
          ToDate: getTodayDate(), // Set ToDate
        }));
        if (!addCategoryModal) {
          setAddCategoryModal(true);
        }
        setLocationState(null); // Clear locationState after use
      }
    }
  }, [locationState, shiftemployeedata, addCategoryModal]);

  useEffect(() => {
    const isadmindata = localStorage.getItem("IsAdmin");
  }, [isAdmin]);

  useEffect(() => {
    const fetchDepartment = async () => {
      try {
        const responses = await getDepartments(UID);
        setDepartment(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchDepartment();
  }, []);

  useEffect(() => {
    const fetchemployee = async () => {
      try {
        const responses = await getEmployee(UID);
        setEmployee(responses.data.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching profit centers:", error);
      }
    };
    fetchemployee();
  }, []);

  useEffect(() => {
    const transformedData = processData(dataFilter);
    setProcessedData(transformedData);
  }, [dataFilter]);

  useEffect(() => {
    fetchduties();
  }, [location.state?.date]);

  useEffect(() => {
    setDataFilter(duties);
  }, [duties]);

  useEffect(() => {
    const currentDate = getTodayDate();
    setDate(currentDate);
    setDutyData((prev) => ({
      ...prev,
      DateValue: currentDate,
    }));
    setLoading(true);
    fetchShiftEmployees();
    fetchShifts();
    fetchduties();
  }, []);

  useEffect(() => {
    fetchShiftEmployees();
  }, [dutyData.DateValue]);

  useEffect(() => {
    // Filter employees based on isAdmin
    const filteredEmployees = shiftemployeedata.filter((employee) => {
      return isAdmin == 1
        ? dutyData.DepartmentId === employee.DepartmentID
        : employee.DepartmentID === DepId;
    });

    const updatedOptions = filteredEmployees
      .filter((employee) => {
        return true; // Keep all employees after department filter
      })
      .map((employee) => ({
        value: employee.Id,
        name: employee.Name,
        DeShiftId: employee.DeShiftId,
        shiftId: employee.ShiftId,
        isAssigned: employee.IsAssigned,
        DepartmentID: employee.DepartmentID,
        shifts: Array.from(
          new Set(
            employee.ShiftId.split(",").map(
              (shiftId) => shiftData.find((el) => el.Id === shiftId)?.Name
            )
          )
        ).join(", "),
      }));

    setShiftemployeeOptions(updatedOptions);
  }, [dutyData.DepartmentId, shiftemployeedata, shiftData, DepId, isAdmin]);

  return (
    <>
      {open && (
        <div className="fixed inset-0 bg-bg-transparent backdrop-blur-sm flex justify-center items-start pt-5 z-50">
          <div className="bg-white p-6 rounded-lg shadow-md w-[500px] mx-4 md:mx-0 z-60 mt-10">
            <p className="text-center mb-4 text-lg font-semibold">
              {confirmationMessage}
            </p>
            <div className="flex justify-end">
              <button
                className="bg-gray-500 text-white py-2 px-4 rounded-md hover:bg-gray-600 transition-colors mr-5"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className="bg-red-500 text-white py-2 px-4 rounded-md hover:bg-red-600 transition-colors"
                onClick={handleSubmit}
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex flex-wrap items-center justify-between mb-8 gap-4">
        <div className="w-full sm:w-auto">
          <Breadcrumb title="Shift Allocation" />
        </div>
        <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto">
          {/* <button
            onClick={goToDutyMuster}
            className="text-blue-600 hover:text-blue-800 flex items-center space-x-1"
          >
            <IconClipboard className="text-2xl" />
            <span className="hidden sm:inline text-sm font-medium">Duty Muster</span>
          </button> */}
        </div>
        <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto"></div>
        <div className="flex flex-wrap items-center gap-4 w-full sm:w-auto mt-4">
          <div className="flex flex-wrap items-center gap-4">
            <div className="flex flex-col">
              <input
                type="date"
                id="date-input"
                className="w-full sm:w-[200px] md:w-[250px] lg:w-[400px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                value={date}
                onChange={(e) => setDate(e.target.value)}
              />
            </div>
            <div className="flex flex-col">
              <input
                type="date"
                id="to-date-input"
                className="w-full sm:w-[200px] md:w-[250px] lg:w-[400px] px-3 py-2 border border-gray-400 rounded-md focus:outline-none focus:ring-0 focus:border-gray-600"
                value={toDate ? toDate : new Date().toISOString().split("T")[0]}
                onChange={(e) => setToDate(e.target.value)}
              />
            </div>
            <button
              className="btn btn-success self-start sm:self-center"
              onClick={handleShowClick}
            >
              Show
            </button>
          </div>
          <div className="flex flex-wrap items-center gap-2 p-5 bg-gray-100 rounded">
            <button
              className="bg-sky rounded-[4px] px-4 py-2 sm:px-10 sm:py-[8px]"
              onClick={handleFilterClick}
            >
              <IconFilter className="text-white w-[18px] h-[18px]" />
            </button>
            <div className="relative w-full sm:w-auto">
              <input
                type="text"
                id="search"
                value={filterText}
                onChange={(e) => setFilterText(e.target.value)}
                placeholder="Search by Shift"
                className="w-full sm:w-64 px-3 py-2 bg-gray-50 border border-gray-200 rounded-md placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <button
              onClick={handleClear}
              className="btn btn-danger mt-2 sm:mt-0 sm:ml-4"
            >
              Clear
            </button>
          </div>
          <button
            onClick={openAddCategoryModal}
            className="btn btn-primary mt-2 sm:mt-0"
          >
            Add Duty
          </button>
        </div>
      </div>

      {isFilterVisible && (
        <FilterComponent
          columns={columnsFilter}
          data={duties}
          onFilter={handleFilter}
        />
      )}

      <div className="bg-bg-dark rounded-lg shadow-light md:p-20 p-15">
        <div className="react-data-table">
          {loading ? (
            <Loading />
          ) : (
            <ReactDataTable
              columns={columnsFilter}
              data={filteredItems}
              pagination
              paginationResetDefaultPage={resetPaginationToggle}
              subHeader
              subHeaderComponent={subHeaderComponentMemo}
            />
          )}
        </div>
      </div>

      {addCategoryModal && (
        <>
          <div className="fixed p-15 w-full max-w-[1000px] left-[50%] top-[50%] translate-x-[-50%] translate-y-[-50%] z-[6]">
            <div className="py-10 md:px-10 px-[7px] bg-bg-dark rounded-lg shadow-light">
              <h5 className="relative text-[16px]/[19.2px] font-medium md:px-10 px-[7px] py-10 mb-20 text-center border-b border-border">
                ADD DUTY
                <span className="absolute top-0 right-0">
                  <button
                    onClick={closeAddCategoryModal}
                    className="btn flex items-center justify-center"
                  >
                    ✖
                  </button>
                </span>
              </h5>
              <form
                onSubmit={handleClickOpen}
                className="my-10 md:px-10 px-[7px]"
              >
                <div className="my-10 md:px-10 px-[7px] max-h-[70vh] overflow-auto cus-scrollbar">
                  <div className="flex justify-end">
                    Note: Employees with an already assigned shift will be shown
                    in <span className="text-red-600 ml-1">red</span>
                  </div>
                  <div className="grid grid-cols-12 gap-20">
                    <div className="form-group flex col-span-12"></div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        From <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="date"
                        required
                        name="DateValue"
                        placeholder="date"
                        value={dutyData.DateValue}
                        min={getTodayDate(isAdmin)}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        To <span style={{ color: "red" }}>*</span>
                      </label>
                      <input
                        type="date"
                        id="ToDate"
                        required
                        name="ToDate"
                        placeholder="date"
                        value={dutyData.ToDate}
                        min={getTodayDate(isAdmin)}
                        onChange={handleChange}
                      />
                    </div>
                    {isAdmin == 1 ? (
                      <div className="form-group flex col-span-12 flex-col">
                        <label>
                          Select Department
                          <span style={{ color: "red" }}> *</span>
                        </label>
                        <select
                          name="DepartmentId"
                          value={dutyData.DepartmentId || ""}
                          onChange={handleChange}
                          required
                        >
                          <option value="">Select department</option>
                          {department?.map((el) => (
                            <option key={el.Id} value={el.Id}>
                              {el.Name}
                            </option>
                          ))}
                        </select>
                      </div>
                    ) : (
                      ""
                    )}
                    <div className="form-group flex col-span-12 flex-col">
                      <label>
                        Shift
                        <span style={{ color: "red" }}> *</span>
                      </label>
                      <select
                        name="ShiftId"
                        value={dutyData.ShiftId || ""}
                        onChange={handleChange}
                        required
                      >
                        <option value="">Select Shift</option>
                        {filteredShifts?.map((shift) => (
                          <option key={shift.Id} value={shift.Id}>
                            {shift.Name}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="form-group col-span-12 mb-4">
                      <label className="block text-sm font-medium mb-2">
                        Employee <span className="text-red-500">*</span>
                      </label>
                      <div className="border rounded-md p-3 bg-white shadow-sm">
                        <div className="flex items-center mb-3 pb-2 border-b">
                          <label className="flex items-center cursor-pointer">
                            <input
                              type="checkbox"
                              className="form-checkbox h-[15px] w-[15px] text-blue-600"
                              checked={
                                shiftemployeeOptions?.length > 0 &&
                                dutyData.EmpId?.length ===
                                  shiftemployeeOptions.filter(
                                    (option) => !option.shifts
                                  ).length
                              }
                              onChange={(e) => {
                                if (e.target.checked) {
                                  setDutyData({
                                    ...dutyData,
                                    EmpId: shiftemployeeOptions
                                      .filter((option) => !option.shifts)
                                      .map((option) => option.value),
                                  });
                                } else {
                                  setDutyData({ ...dutyData, EmpId: [] });
                                }
                              }}
                            />
                            <span className="ml-2 font-medium">Select All</span>
                          </label>
                        </div>
                        <div
                          className="max-h-[100px] overflow-y-auto pr-2 custom-scrollbar"
                          style={{
                            scrollbarWidth: "thin",
                            scrollbarColor: "#cbd5e0 #f7fafc",
                          }}
                        >
                          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                            {shiftemployeeOptions?.map((option) => (
                              <div
                                key={option.value}
                                className="flex items-start mb-2"
                              >
                                <div className="flex-shrink-0 mt-1">
                                  <input
                                    type="checkbox"
                                    name="employee"
                                    className="form-checkbox h-[15px] w-[15px] text-blue-600 cursor-pointer"
                                    value={option.value}
                                    checked={dutyData?.EmpId?.includes(
                                      option.value
                                    )}
                                    onChange={handleChange}
                                    id={`employee-${option.value}`}
                                    disabled={option.shifts}
                                  />
                                </div>
                                <label
                                  htmlFor={`employee-${option.value}`}
                                  className="ml-2 text-sm cursor-pointer leading-normal break-words flex-1"
                                >
                                  <div className="flex items-center gap-2">
                                    <Link
                                      to="/dutymuster"
                                      state={{ EmpId: option.value }}
                                    >
                                      <span
                                        className={
                                          option.isAssigned === 1
                                            ? "text-red-600"
                                            : ""
                                        }
                                      >
                                        {option.name}
                                      </span>
                                    </Link>
                                    {option.shifts && (
                                      <span className="text-gray-600">
                                        ({option.shifts})
                                      </span>
                                    )}
                                  </div>
                                </label>
                              </div>
                            ))}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="form-group flex col-span-12 flex-col">
                      <label>Remarks</label>
                      <input
                        type="text"
                        id="remarks"
                        name="Remarks"
                        placeholder="Remarks"
                        value={dutyData.Remarks}
                        onChange={handleChange}
                      />
                    </div>
                  </div>
                </div>
                <div className="md:px-10 px-[7px] flex gap-10 justify-end py-10">
                  <button
                    type="button"
                    onClick={clearData}
                    className="btn btn-outline-secondary"
                    disabled={loading}
                  >
                    Clear
                  </button>
                  <button
                    type="submit"
                    className="btn btn-primary"
                    disabled={loading}
                  >
                    {loading ? "Loading..." : "Submit"}
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="fixed z-[5] w-full h-full left-0 top-0 bg-bg-transparent backdrop-blur-[5px]"></div>
        </>
      )}
    </>
  );
}
